import { format } from 'date-fns';

const formatDate = (date) => (date ? format(date, 'yyyyMMdd') : null);

export default formatDate;
